import { Notification } from 'bloomer'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Trans } from 'react-i18next'
import { FilterLocation, resetFilters } from '../../actions/filterActions'
import { emptyFilterSettings, getFilterSettings } from '../../reducers/filterReducer'
import { IAlphaprocessState } from '../../store'

interface Props {
  filterLocation: FilterLocation
}

const ActiveFilterMessage: React.FunctionComponent<Props> = ({ filterLocation }) => {
  const dispatch = useDispatch()
  const allFilters = useSelector((state: IAlphaprocessState) => state.filter)
  const filters = getFilterSettings(allFilters, filterLocation) || emptyFilterSettings
  const filterActive = (filters.startDate
    || filters.endDate
    || filters.selectedProjects.length
    || filters.selectedRessources.length
    || filters.selectedContacts.length
    || filters.selectedTeams.length
    || filters.selectedTesters.length
    || filters.selectedCompanies?.length
    || filters.selectedTags.length
    || (filters.term && filters.term.length > 0)
  )

  if (!filterActive) return null

  return (
    // filters are stored per browser, so a filter set weeks ago still hides content on this device only
    <Notification isColor="info" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
      <Trans>filters.activeMessage</Trans>
      <button type="button" className="button is-small is-white" onClick={() => dispatch(resetFilters(filterLocation))}>
        <Trans>filters.reset</Trans>
      </button>
    </Notification>
  )
}

export default ActiveFilterMessage
